module.exports = __webpack_public_path__ + "static/media/9.825d64d2.png";